import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import AudiLogo from './AudiLogo';

const { FiPhone, FiMail, FiMapPin, FiClock, FiFacebook, FiTwitter, FiInstagram, FiLinkedin, FiExternalLink } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <AudiLogo className="h-10 w-auto" />
              <span className="text-xl font-light uppercase tracking-wider">Halifax Audi</span>
            </div>
            <p className="text-gray-400 mb-4">
              Halifax's premier Audi dealership, offering exceptional German engineering and luxury vehicles. Proudly serving Nova Scotia for over 15 years.
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiFacebook} className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiTwitter} className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiInstagram} className="w-5 h-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-light uppercase tracking-wider mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/models" className="text-gray-400 hover:text-white transition-colors">
                  Audi Models
                </Link>
              </li>
              <li>
                <Link to="/build-your-audi" className="text-gray-400 hover:text-white transition-colors">
                  Build & Price
                </Link>
              </li>
              <li>
                <Link to="/inventory" className="text-gray-400 hover:text-white transition-colors">
                  New Inventory
                </Link>
              </li>
              <li>
                <Link to="/inventory?type=certified" className="text-gray-400 hover:text-white transition-colors">
                  Certified Pre-Owned
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                  Service Centre
                </Link>
              </li>
              <li>
                <Link to="/financing" className="text-gray-400 hover:text-white transition-colors">
                  Financing
                </Link>
              </li>
              <li>
                <Link to="/parts" className="text-gray-400 hover:text-white transition-colors">
                  Parts & Accessories
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-light uppercase tracking-wider mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-2">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-red-600 mt-1" />
                <span className="text-gray-400">
                  6077 Columbus St<br />
                  Halifax, NS B3K 0E9
                </span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-red-600" />
                <span className="text-gray-400">(902) 455-7890</span>
              </div>
              <div className="flex items-center space-x-2">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-red-600" />
                <span className="text-gray-400">info@halifaxaudi.ca</span>
              </div>
            </div>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-lg font-light uppercase tracking-wider mb-4">Business Hours</h3>
            <div className="space-y-2">
              <div className="flex items-start space-x-2">
                <SafeIcon icon={FiClock} className="w-5 h-5 text-red-600 mt-1" />
                <div className="text-gray-400">
                  <div>Sales Department:</div>
                  <div>Mon-Thu: 9AM-8PM</div>
                  <div>Fri-Sat: 9AM-6PM</div>
                  <div>Sunday: Closed</div>
                  <div className="mt-2">
                    <strong>Service Centre:</strong><br />
                    Mon-Fri: 7:30AM-5:30PM<br />
                    Sat: 8AM-4PM<br />
                    Sun: Closed
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-center md:text-left">
              © 2024 Halifax Audi. All rights reserved. |{' '}
              <a href="/privacy" className="hover:text-white ml-1">Privacy Policy</a> |{' '}
              <a href="/terms" className="hover:text-white ml-1">Terms of Service</a>
            </p>
            <div className="flex items-center space-x-2 text-gray-400">
              <span>Designed by</span>
              <a
                href="https://shawnryder.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-red-600 hover:text-red-400 transition-colors font-semibold flex items-center space-x-1"
              >
                <span>Shawn Ryder Digital</span>
                <SafeIcon icon={FiExternalLink} className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;